// src/ui-components/Footer.js

import React from 'react';
import { Box, Typography } from '@mui/material';

const Footer = () => {
    return (
        <Box component="footer"  className="text-white py-3 text-center" sx={{position: "fixed", bottom: 0, left: 0, right: 0, backgroundColor: "#009EDB",zIndex: 1000,}}>
        <Typography variant="body2">
      
          © {new Date().getFullYear()} UNEP &nbsp; | &nbsp;
      
          <a href="https://www.unep.org/terms-use"  target="_blank"  rel="noopener noreferrer" className="text-white text-decoration-none">
            Terms of Use
          </a>      
          &nbsp; | &nbsp;      
          <a href="https://www.unep.org/privacy"  target="_blank" rel="noopener noreferrer"  className="text-white text-decoration-none">
            Privacy
          </a>      
          &nbsp; | &nbsp;      
          <a href="https://www.unep.org/about-un-environment/why-does-un-environment-matter/un-environment-project-concern" target="_blank"  rel="noopener noreferrer" className="text-white text-decoration-none">
            Report Project Concern
          </a>      
          &nbsp; | &nbsp;      
          <a  href="https://www.unep.org/about-un-environment-programme/policies-and-strategies/reporting-potential-scam" target="_blank" rel="noopener noreferrer" className="text-white text-decoration-none">
            Report Scam
          </a>      
          &nbsp; | &nbsp;      
          <a href="/contact-us"  target="_blank" rel="noopener noreferrer" className="text-white text-decoration-none">
            Contact Us
          </a>
      
        </Typography>
      </Box>
    );
};

export default Footer;
